import { BrowserCacheLocation, LogLevel } from "@azure/msal-browser";

export const msalConfig = {
	auth: {
		clientId: process.env.REACT_APP_MS_CLIENT_ID,
		authority: process.env.REACT_APP_MS_AUTHORITY,
		redirectUri: window.location.origin,
		postLogoutRedirectUri: `${window.location.origin}/login`,
	},
	cache: {
		cacheLocation: BrowserCacheLocation.SessionStorage,
		storeAuthStateInCookie: false,
	},
	system: {
		loggerOptions: {
			loggerCallback: (level, message, containsPii) => {
				if (containsPii) {
					return;
				}
				switch (level) {
					case LogLevel.Error:
						console.error(message);
						return;
					case LogLevel.Info:
						console.info(message);
						return;
					case LogLevel.Verbose:
						console.debug(message);
						return;
					case LogLevel.Warning:
						console.warn(message);
						return;
					default:
						return;
				}
			},
		},
	},
};

export const loginRequest = {
	scopes: ["User.Read"],
};

export const GCID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
